import GoalLibraryCard from "./GoalLibraryCard"
export default GoalLibraryCard
